<template>
	<div>
		<div style="display: flex; width: 100%">
			<div style="width: 100%; margin-top: 10px">
				<h3 style="margin-left: 10px">
					{{
						project_tasksItems.length !== 0 &&
						project_tasksItems.filter((el) => el.id.includes(project_tasks))
							.length !== 0
							? project_tasksItems.filter((el) =>
									el.id.includes(project_tasks)
							  )[0].name
							: ""
					}}
					( {{ moment(from_date[0]).format("Do MMM YYYY") }} to
					{{ moment(from_date[0]).format("Do MMM YYYY") }})
				</h3>
			</div>
		</div>
		<el-card shadow="none" style="margin-top: 20px">
			View
			<div style="display: flex; justify-content: center; width: 100%">
				<div style="width: 20%">
					<div>
						<el-select
							style="margin-top: 5px; width: 100%"
							class="select"
							v-model="toggle"
							filterable
							placeholder="Select View"
							popper-class="custom-dropdown"
							@change="changeQuestion()"
						>
							<el-option
								v-for="(item, key) in toggleItems"
								:key="key"
								:label="item.name"
								:value="item.id"
							>
							</el-option>
						</el-select>
					</div>
				</div>
				<div
					style="width: 10%; margin-top: 10px"
					:style="storeObj.is_critical ? 'color:red;font-weight:bold' : ''"
				>
					{{ storeObj.is_critical ? "CRITICAL" : "" }}
				</div>
				<div style="max-width: 15%; margin-left: auto">
					<el-button
						icon="el-icon-download"
						style="margin-top: 0px; margin-left: 20px"
						class="button-class-new"
						@click="exportCSV()"
					>
						Download Reports
					</el-button>
				</div>
			</div>
			<div>
				<el-row
					v-loading="isloading"
					class="reports-table1"
					style="margin-top: 14px"
				>
					<el-col :span="24">
						<el-table
							style="text-transform: capitalize; word-break: break-word"
							height="500"
							:data="
								filteredreportsTableP_T
									.filter(
										(el) =>
											!selected_Location.length ||
											selected_Location.includes(el.store_name)
									)
									.filter(
										(el) =>
											!selected_EmpId.length ||
											selected_EmpId.includes(el.emp_id)
									)
									.filter(
										(el) =>
											!selected_Employee.length ||
											selected_Employee.includes(el.name)
									)
									.filter(
										(el) =>
											!selected_Designation.length ||
											selected_Designation.includes(el.designation)
									)
									.filter(
										(el) =>
											!selected_Region.length ||
											selected_Region.includes(el.region)
									)
									.filter(
										(el) =>
											!selected_SubRegion.length ||
											selected_SubRegion.includes(el.subregion)
									)

									.filter(
										(el) =>
											!search ||
											el.store_name.toLowerCase().includes(search.toLowerCase())
									)
									.filter(
										(el, index) => index >= startNumber - 1 && index < endNumber
									)
							"
						>
							<el-table-column fixed width="150px" label="Location">
								<template slot="header" slot-scope="scope">
									Location
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Location"
											size="mini"
											:placeholder="`Search Location`"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Location">
												<el-checkbox
													v-for="(
														formItem, index
													) in uniqueLocationNames.filter(
														(el) =>
															!searched_Location ||
															el
																.toLowerCase()
																.includes(searched_Location.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Location = [...uniqueLocationNames]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Location = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Location.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div
										style="text-transform: capitalize; word-break: break-word"
									>
										{{
											scope.row.store_name != undefined
												? scope.row.store_name
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="150px"
								prop="project_completion_date"
								label="Completion Date"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Completion Date
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pcompletion_date_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Pcompletion_date_order = 'asc';
											"
										></i>
										<i
											v-if="
												last_Pcompletion_date_order == '' ||
												last_Pcompletion_date_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Pcompletion_date_order = 'desc';
											"
										></i>
									</span>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.project_completion_date != 0
												? moment
														.utc(scope.row.project_completion_date)
														.local()
														.format("Do MMM YYYY")
												: "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="name"
								label="Employee"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Employee
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Employee"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Employee">
												<el-checkbox
													v-for="(formItem, index) in uniqueEmployee.filter(
														(el) =>
															!searched_Employee ||
															el
																.toLowerCase()
																.includes(searched_Employee.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Employee = [...uniqueEmployee]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Employee = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Employee.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{ scope.row.name != 0 ? scope.row.name : "-" }}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="designation"
								label="Designation"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Designation
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Designation"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Designation">
												<el-checkbox
													v-for="(formItem, index) in uniqueDesignation.filter(
														(el) =>
															!searched_Designation ||
															el
																.toLowerCase()
																.includes(searched_Designation.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Designation = [...uniqueDesignation]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Designation = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Designation.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<div style="word-break: break-word">
										{{
											scope.row.designation != 0 ? scope.row.designation : "-"
										}}
									</div>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="region"
								label="Region"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Region
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_Region"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_Region">
												<el-checkbox
													v-for="(formItem, index) in uniqueRegion.filter(
														(el) =>
															!searched_Region ||
															el
																.toLowerCase()
																.includes(searched_Region.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_Region = [...uniqueRegion]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_Region = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_Region.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column
								width="160px"
								prop="subregion"
								label="Sub Region"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Sub Region
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searched_SubRegion"
											size="mini"
											placeholder="Search Employee"
										></el-input>
										<div
											style="
												max-height: 200px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group v-model="selected_SubRegion">
												<el-checkbox
													v-for="(formItem, index) in uniqueSubRegion.filter(
														(el) =>
															!searched_SubRegion ||
															el
																.toLowerCase()
																.includes(searched_SubRegion.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="formItem"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selected_SubRegion = [...uniqueSubRegion]"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="selected_SubRegion = []"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selected_SubRegion.length"
												src="../../../../assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../assets/images/filterBlack.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column
								prop="total_score"
								width="150px"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Total Points
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pscore_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = 'asc';
												last_Pcompletion_date_order = '';
											"
										></i>
										<i
											v-if="
												last_Pscore_order == '' || last_Pscore_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = 'desc';
												last_Pcompletion_date_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="current_score"
								width="150px"
								style="word-break: break-word"
							>
								<template slot="header" slot-scope="scope">
									Points Achieved
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Ptotal_points_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = 'asc';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
												last_Pcompletion_date_order = '';
											"
										></i>
										<i
											v-if="
												last_Ptotal_points_order == '' ||
												last_Ptotal_points_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = '';
												last_Ptotal_points_order = 'desc';
												last_Pscore_order = '';
												last_Ppoints_available_order = '';
												last_Pcompletion_date_order = '';
											"
										></i>
									</span>
								</template>
							</el-table-column>

							<el-table-column width="160px">
								<template slot="header" slot-scope="scope">
									Score %
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_Pscore_completion_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = 'asc';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ptotal_points_order = '';
												last_Pcompletion_date_order = '';
											"
										></i>
										<i
											v-if="
												last_Pscore_completion_order == '' ||
												last_Pscore_completion_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_Pcompletion_order = '';
												last_status_order = '';
												last_Pscore_completion_order = 'desc';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ptotal_points_order = '';
												last_Pcompletion_date_order = '';
											"
										></i>
									</span>
								</template>
								<template slot-scope="scope">
									<div>{{ getScorePer(scope.row) }}%</div>
								</template>
							</el-table-column>
							<el-table-column prop="grade" label="Grade">
								<template slot-scope="scope">
									<div>{{ scope.row["grade"] }}</div>
								</template>
							</el-table-column>
							<el-table-column width="160px" prop="status">
								<template slot="header" slot-scope="scope">
									Status
									<span slot="reference" class="cursor-pointer">
										<i
											v-if="last_status_order == 'desc'"
											class="el-icon-caret-top"
											style="font-size: 12px"
											v-on:click="
												last_status_order = 'asc';
												last_Pcompletion_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
										<i
											v-if="
												last_status_order == '' || last_status_order == 'asc'
											"
											class="el-icon-caret-bottom"
											style="font-size: 12px"
											v-on:click="
												last_status_order = 'desc';
												last_Pcompletion_order = '';
												last_Pscore_completion_order = '';
												last_Ppoints_available_order = '';
												last_Pscore_order = '';
												last_Ppoints_achieved_order = '';
											"
										></i>
									</span>
								</template>

								<template slot-scope="scope">
									<el-tag
										size="small"
										style="border-radius: 12px; width: 80px; text-align: center"
										:style="
											scope.row.status != 'inprogress'
												? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
												: 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
										"
										>{{
											scope.row.status != "inprogress"
												? "Completed"
												: "Incomplete"
										}}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column
								v-if="toggle != 'inprogress'"
								fixed="right"
								width="180px"
							>
								<template slot-scope="scope">
									<div
										@click="
											scope.row.canDownload ? download_report(scope.row) : ''
										"
										:style="
											!scope.row.canDownload
												? 'cursor:not-allowed; color:black'
												: 'color:#d26300;cursor:pointer'
										"
									>
										{{
											scope.row.loading ? "Downloading..." : scope.row.report
										}}
									</div>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row :gutter="10" class="mt-3">
					<el-col :span="8" class="text-left">
						<div>
							<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
							{{ filteredreportsTableP_T.length }} results
						</div>
					</el-col>
					<el-col :span="8" class="text-center">
						<el-select
							v-model="perPage"
							name="per_page"
							placeholder="select per page"
							style="width: 90px !important"
							size="mini"
						>
							<el-option label="10" :value="10"></el-option>
							<el-option label="25" :value="25"></el-option>
							<el-option label="50" :value="50"></el-option>
							<el-option label="100" :value="100"></el-option>
						</el-select>
						&nbsp;<b>per page</b>
					</el-col>
					<el-col :span="8" class="text-right">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="filteredreportsTableP_T.length"
							:page-size="perPage"
							:current-page.sync="currentPage"
						></el-pagination>
					</el-col>
				</el-row>
			</div>
		</el-card>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";
import { mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";

var moment = require("moment");
import Vue from "vue";
export default {
	props: {
		storeObj: String,
		from_date: Date,
		to_date: Date,
		topNonComplaintsData: Array,
		project_tasksItems: Array,
		project_tasks: String,
		locations: Array,
		is_outlet: Boolean,
		forms: String,
		category: String,
		designation: String,
		user: String,
		status: String,
		question: String,
		selectedLocationType: String,
		locationItems: Array,
	},
	data: () => ({
		moment: moment,
		currentPage: 1,
		perPage: 10,
		searched_Location: "",
		last_occurance_order: "",
		last_completed_order: "",
		last_completion_order: "",
		last_points_achieved_oeder: "",
		last_average_score_order: "",
		last_total_points_order: "",
		last_score_order: "",
		last_Pcompletion_order: "",
		last_Pscore_completion_order: "",
		last_Ptotal_points_order: "",
		last_Ppoints_available_order: "",
		last_Pcompletion_date_order: "",
		last_Pscore_order: "",
		selected_EmpId: [],
		selected_Employee: [],
		selected_Region: [],
		selected_SubRegion: [],
		last_status_order: "",
		selected_Designation: [],
		searched_EmpId: "",
		searched_Employee: "",
		searched_Region: "",
		searched_SubRegion: "",
		searched_Designation: "",
		isloading: false,
		selected_Location: [],
		reportsTable1: [],
		search: "",
		loading: false,
		toggle: "total",
		toggleItems: [
			{ name: "All Projects", id: "total" },
			{ name: "Completed", id: "completed" },
			{ name: "Pending", id: "inprogress" },
			{ name: "Failed", id: "fail" },
		],
	}),
	computed: {
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				[...this.reportsTable1].length
			);
			return end;
		},
		uniqueLocationNames() {
			let arr = [
				...new Set([...this.reportsTable1].map((el) => el.store_name)),
			];
			return arr;
		},
		uniqueEmployee() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) => (el.name != 0 ? el.name : ""))
				),
			];
			return arr;
		},
		uniqueRegion() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) => (el.region != 0 ? el.region : ""))
				),
			];
			return arr;
		},
		uniqueSubRegion() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) =>
						el.subregion != 0 ? el.subregion : ""
					)
				),
			];
			return arr;
		},
		uniqueDesignation() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) =>
						el.designation != 0 ? el.designation : ""
					)
				),
			];
			return arr;
		},
		filteredreportsTableP_T() {
			let arr1 = [...this.reportsTable1];
			if (this.last_status_order) {
				if (this.last_status_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["status"].localeCompare(b["status"]));
				}
				if (this.last_status_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["status"].localeCompare(a["status"]));
				}
			}
			if (this.last_Pcompletion_order) {
				if (this.last_Pcompletion_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort(
						(a, b) => a["forms_completion_%"] - b["forms_completion_%"]
					);
				}
				if (this.last_Pcompletion_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort(
						(a, b) => b["forms_completion_%"] - a["forms_completion_%"]
					);
				}
			}
			if (this.last_Pscore_completion_order) {
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["score_completion_%"] - b["score_completion_%"]
					);
				}
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["score_completion_%"] - a["score_completion_%"]
					);
				}
			}
			if (this.last_Pscore_order) {
				if (this.last_Pscore_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["total_score"] - b["total_score"]);
				}
				if (this.last_Pscore_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["total_score"] - a["total_score"]);
				}
			}

			if (this.last_Ptotal_points_order) {
				if (this.last_Ptotal_points_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["current_score"] - b["current_score"]);
				}
				if (this.last_Ptotal_points_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["current_score"] - a["current_score"]);
				}
			}
			if (this.last_Ppoints_available_order) {
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["completed_total_score"] - b["completed_total_score"]
					);
				}
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["completed_total_score"] - a["completed_total_score"]
					);
				}
			}
			if (this.last_Pcompletion_date_order) {
				if (
					this.last_Pcompletion_date_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort((a, b) => {
						return (
							moment(a["project_completion_date"]).toDate() -
							moment(b["project_completion_date"]).toDate()
						);
					});
				}
				if (
					this.last_Pcompletion_date_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort((a, b) => {
						return (
							moment(b["project_completion_date"]).toDate() -
							moment(a["project_completion_date"]).toDate()
						);
					});
				}
			}
			this.$forceUpdate();
			return arr1;
		},
	},
	mounted() {
		this.toggle = this.storeObj;
		this.listSummaryDetailsViewData(this.toggle);
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		exportCSV() {
			this.addDownloadingReportCountAction("Report");
			let data = null;
			data = this.reportsTable1.map((el) => {
				let item = {
					Location: el.store_name,
					"Completion Date": this.moment(el.project_completion_date).format(
						"Do MMM YYYY"
					),
					Employee: el.name,
					Designation: el.designation,
					Region: el.region,
					"Sub Region": el.subregion,
					"Total Points": el.total_score,
					"Points Achieved": el.current_score,
					"Score %": this.getScorePer(el),
					Grade: el.grade,
					Status: el.status,
				};
				return item;
			});
			const fileName = `${
				this.toggleItems.length != 0
					? this.toggleItems.filter((el) => el.id.includes(this.toggle))[0].name
					: "-"
			}  - ${
				this.project_tasksItems.length != 0
					? this.project_tasksItems.filter((el) =>
							el.id.includes(this.project_tasks)
					  )[0].name
					: "-"
			} ( ${this.moment(this.from_date).format("Do MMM YYYY")} - ${this.moment(
				this.to_date
			).format("Do MMM YYYY")} )`;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
			this.removeDownloadingReportCountAction();
		},
		download_report(item) {
			Vue.set(item, "loading", true);
			Vue.set(item, "canDownload", false);
			for (let i = 0; i < this.reportsTable1.length; i++) {
				this.reportsTable1[i].canDownload = false;
			}
			this.handleClick(item);
			return item;
		},
		async handleClick(row) {
			try {
				await this.downloadCsvReport(row);
			} catch (error) {
				console.error("Error downloading report:", error);
			}
		},
		async downloadCsvReport(item) {
			this.addDownloadingReportCountAction("Report");
			this.is_csv_loading = true;
			const params = {
				project_execution: item.project_execution_id,
			};
			try {
				const response = await formBuilderServices.getDashboarLocationReport(
					params
				);
				const fileURL =
					"data:application/pdf;charset=UTF-8," +
					encodeURIComponent(response.data);
				const fileLink = document.createElement("a");
				fileLink.href = fileURL;
				fileLink.setAttribute(
					"download",
					`${
						(this.project_tasksItems.length != 0
							? this.project_tasksItems.find((el) =>
									el.id.includes(this.project_tasks)
							  ).name
							: "-") +
						" - " +
						this.moment(this.from_date).format("Do MMM YYYY") +
						"/" +
						this.moment(this.to_date).format("Do MMM YYYY") +
						".pdf"
					}`
				);
				document.body.appendChild(fileLink);
				fileLink.click();
				this.removeDownloadingReportCountAction();
				Vue.set(item, "loading", false);
				Vue.set(item, "canDownload", true);
				for (let i = 0; i < this.reportsTable1.length; i++) {
					this.reportsTable1[i].canDownload = true;
				}
			} catch (err) {
				console.error(err);
				this.$notify.error({
					title: "Error",
					message: "Something went wrong!",
				});
				Vue.set(item, "loading", false);
				this.is_csv_loading = false;
				Vue.set(item, "canDownload", true);
				for (let i = 0; i < this.reportsTable1.length; i++) {
					this.reportsTable1[i].canDownload = true;
				}
				this.removeDownloadingReportCountAction();
			}
			// finally {
			// 	this.is_csv_loading = false;
			// 	Vue.set(item, 'loading', false);
			// 	this.canDownload(item); // Update the row's report text
			// }
		},
		getScorePer(item) {
			return ((item.current_score / item.total_score) * 100).toFixed(2);
		},
		// getNonCompliantQuestionDetailsAPI() {
		// 	let start_date = moment(this.from_date).format("yyyy-MM-DD");
		// 	let end_date = moment(this.from_date).format("yyyy-MM-DD");
		// 	let params = {
		// 		form_question_id: this.question,
		// 		start_date: start_date,
		// 		end_date: end_date,
		// 	};
		// 	formBuilderServices.getNonCompliantQuestionDetails(params).then((res) => {
		// 		this.reportsTable1 = JSON.parse(res.data).data;
		// 	});
		// },
		async listSummaryDetailsViewData(type) {
			try {
				let start_date = moment(this.from_date).format("yyyy-MM-DD");
				let end_date = moment(this.to_date).format("yyyy-MM-DD");
				let user = this.user != "All" ? this.user : null;
				let designation = this.designation != "All" ? this.designation : null;
				let params = {};
				let lastElement = [];
				let lastIndex = 0;
				if (this.selectedLocationType == "region") {
					if (this.locations.length == 0) {
						this.locations = this.locationItems[0].id;
					} else {
						if (typeof this.locations != "string") {
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastIndex = j;
								}
							}
							for (let i = 0; i < this.locations.length; i++) {
								for (let j = 0; j < this.locations[i].length; j++) {
									lastElement.push(this.locations[i][lastIndex]);
								}
							}
							lastElement = [...new Set(lastElement)].filter(Boolean);
						} else {
							lastElement = [this.locations];
							lastIndex = 0;
						}
					}
				} else if (this.selectedLocationType == "location") {
					if (this.locationItems[0].id == this.locations) {
						this.locations = [];
					} else {
						lastIndex = 3;
						lastElement = this.locations;
					}
				}

				params = {
					filters: {
						outlets: lastIndex == 3 ? lastElement : [],
						countries: lastIndex == 0 ? lastElement : [],
						regions: lastIndex == 1 ? lastElement : [],
						subregions: lastIndex == 2 ? lastElement : [],
					},
					start_date: start_date,
					end_date: end_date,
					project: this.project_tasks,
					form_category: this.category !== "All" ? this.category : null,
					form: this.forms !== "All" ? this.forms : null,
					form_question: this.question !== "All" ? this.question : null,
					basics: "user",
					include_dates: true,
					get_country_avg: false,
					aggregate_on: null,
					users: user != null ? [user] : [],
					designations: designation != null ? [designation] : [],
					status: type == "total" ? null : type,
				};
				if (this.toggle == "fail") { 
					params.status = "completed";
					params.grade = "fail";
				}
				formBuilderServices.getDashboardData(params).then((res) => {
					let reportsTable1 = JSON.parse(res.data).data;
					for (let i = 0; i < reportsTable1.length; i++) {
						if (typeof reportsTable1[i] === "object") {
							if (reportsTable1[i]["forms_completion_%"] == 0) {
								reportsTable1[i].report = "";
							} else {
								reportsTable1[i].report = "Download Report";
							}
							reportsTable1[i].loading = false;
							reportsTable1[i].canDownload = true;
						}
					}
					this.reportsTable1 = reportsTable1;
				});
			} catch (e) {
				console.log(e, "err");
			}
		},
		changeQuestion() {
			this.listSummaryDetailsViewData(this.toggle);
		},
	},
};
</script>
<style lang="scss"></style>
